module.exports = __webpack_public_path__ + "0d360dfed7aa31ad69c01ae9542b6428.pdf";